export const SHARE_METHODS = {
  email: 'email',
  sms: 'sms'
}
